import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IstDatePipe } from './ist-date.pipe';



@NgModule({
  declarations: [
    IstDatePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    IstDatePipe
  ]
})
export class IstDateModule { }
